import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input, TimePicker, Select } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";

const { Content } = Layout;
const Option = Select.Option;
const { TextArea } = Input;

export class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      changeFile: true,
      view: false,
      errors: {},
    };
  }

  onDescriptionChange = (value) => {
    this.setState({ description: value });
  };

  validateForm = (values) => {
    const errors = {};

    if (!values.linkup_corppass_id) {
      errors.linkup_corppass_id = "Linkup Corppass Id is required";
    }

    if (!values.corppass_id) {
      errors.corppass_id = "Corppass Id is required";
    }

    return errors;
  };

  handleSubmit(values, action) {
    this.props.onSubmit(values, this.props.data.id);
    this.props.handleCancel();

    this.setState({
      visible: false,
    });
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <div>
        <div>
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                linkup_corppass_id: this.props.data.linkup_corppass_id,
                corppass_id:
                  this.props.data.corppass_id ||
                  this.props.loginUserData.corppass_id,
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Linkup Corppass Id
                        <Input
                          id="linkup_corppass_id"
                          placeholder="Linkup Corppass Id"
                          value={values.linkup_corppass_id}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.linkup_corppass_id &&
                        touched.linkup_corppass_id ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.linkup_corppass_id}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        Corppass Id
                        <Input
                          id="corppass_id"
                          placeholder="Corppass Id"
                          value={values.corppass_id}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={true}
                        />
                        {errors.corppass_id && touched.corppass_id ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.corppass_id}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <Button
                      type="primary"
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </div>
      </div>
    );
  }
}
